import CourseBatch from './CourseBatch'
import Dashboard from './Dashboard'
import Schedule from './Schedule'
import Student from './Student'
import TeacherList from './TeacherList'

const exportObj = {
    CourseBatch,
    Dashboard,
    Schedule,
    Student,
    TeacherList
}

export default exportObj